import React from "react";
import GamePage from "./pages/GamePage";

function App() {
    return (
        <GamePage/>
    );
}

export default App;
